import { lazy, Suspense } from "react";
import SuspenseLoader from "src/components/SuspenseLoader";
import Bidders from "src/content/cuModule/RfpTemplatePreview/Components/Bidders";
import PreliminaryInfo from "src/content/cuModule/RfpTemplatePreview/Components/PreliminaryInfo";
import ScopeofWork from "src/content/cuModule/RfpTemplatePreview/Components/ScopeofWork";
import Callback from "src/content/pages/Callback";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Dashboard = Loader(lazy(() => import("src/content/cuModule/dashboard")));
const Users = Loader(lazy(() => import("src/content/cuModule/Users")));
const AddUserGroup = Loader(
  lazy(() => import("src/content/cuModule/UserGroups/Components/Create"))
);
const TcsUserGroupCreate = Loader(
  lazy(() => import("src/content/cuModule/UserGroups/Components/CreateMember"))
);

const TemplatesBank = Loader(
  lazy(() => import("src/content/cuModule/TemplatesBank"))
);
const PrefferedPanel = Loader(
  lazy(() => import("src/content/cuModule/PreferredPanel"))
);

const RfpsList = Loader(lazy(() => import("src/content/cuModule/RfpsList")));
const Status404 = Loader(
  lazy(() => import("src/content/pages/Status/Status404"))
);
const HelpCenter = Loader(lazy(() => import("src/content/cuModule/Resources")));
const Profile = Loader(lazy(() => import("src/content/cuModule/Profile")));
const ComingSoon = Loader(
  lazy(() => import("src/content/pages/Status/ComingSoon"))
);

const TApprover = Loader(lazy(() => import("src/content/cuModule/TApprover")));

// RFP's Routes
const RfpForm = Loader(lazy(() => import("src/content/cuModule/DraftNewRfp")));

const Analytics = Loader(lazy(() => import("src/content/cuModule/Analytics")));

const ServicesReview = Loader(
  lazy(() => import("src/content/cuModule/ServicesReview"))
);
const AddReviewSectionOne = Loader(
  lazy(() => import("src/content/cuModule/ServicesReview/AddReviewStageOne"))
);
const AddReviewSectionTwo = Loader(
  lazy(() => import("src/content/cuModule/ServicesReview/AddReviewStageTwo"))
);

const ViewServiceReview = Loader(
  lazy(() => import("src/content/cuModule/ServicesReview/ViewServiceReview"))
)

const TemplateSelect = Loader(
  lazy(() => import("src/content/cuModule/TemplatesBank/TemplateSelect"))
);

const TemplatePreview = Loader(
  lazy(() => import("src/content/cuModule/RfpTemplatePreview"))
);

const PastRfpList = Loader(
  lazy(() => import("src/content/cuModule/RfpsList/PastRfpList"))
);

const PastRfpPreview = Loader(
  lazy(() => import("src/content/cuModule/PastRfpPreview"))
);

const ProposalSideBySide = Loader(
  lazy(() => import("src/content/cuModule/ProposalSideScreen"))
);

const ProposalViewCVs = Loader(
  lazy(() => import("src/content/cuModule/ProposalSideScreen/ViewCVs"))
);

const ProposalSideApprover = Loader(
  lazy(() => import("src/content/cuModule/ProposalSideScreen/ProposalApproval"))
);

const VendorManagement = Loader(
  lazy(() => import("src/content/cuModule/VendorManagement/index"))
);

const FAQ = Loader(lazy(() => import("src/content/cuModule/FAQ")));

export const TcsCuRoutes = [
  {
    path: "",
    element: <Dashboard />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/faq-center",
    element: <FAQ />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate",
    element: <Dashboard />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/dashboard",
    element: <Dashboard />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/users",
    element: <Users />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/analytics",
    element: <Analytics />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "/corporate/services-review",
    element: <ServicesReview />,
    roles: ["system_admin", "t_user"],
  },
  {
    path: "/corporate/add-review",
    element: <AddReviewSectionOne />,
    roles: ["system_admin"],
  },
  {
    path: "/corporate/submit-review/:reviewId",
    element: <AddReviewSectionTwo />,
    roles: ["t_user"],
  },
  {
    path: "/corporate/view-review/:reviewId",
    element: <ViewServiceReview />,
    roles: ["t_user", "system_admin"],
  },
  {
    path: "corporate/profile",
    element: <Profile />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/user-group/create",
    element: <AddUserGroup />,
    roles: ["system_admin"],
  },
  {
    path: "corporate/user-group/edit/:id",
    element: <AddUserGroup />,
    roles: ["system_admin"],
  },
  {
    path: "corporate/user-group/add-members",
    element: <TcsUserGroupCreate />,
    roles: ["system_admin"],
  },
  {
    path: "corporate/user-group/edit-members/:id",
    element: <TcsUserGroupCreate />,
    roles: ["system_admin"],
  },
  {
    path: "corporate/templates-bank-list",
    element: <TemplatesBank />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/template-bank/select-list",
    element: <TemplateSelect />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/past-cr/list",
    element: <PastRfpList />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/coming-soon",
    element: <ComingSoon />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/crs-list",
    element: <RfpsList />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/proposal-selection",
    element: <ProposalSideBySide />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/proposal-selection/view-cvs",
    element: <ProposalViewCVs />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/users",
    element: <Users />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/t-approver",
    element: <TApprover />,
    roles: ["t_approver"],
  },
  {
    path: "corporate/approve-bidder",
    element: <ProposalSideApprover />,
    roles: ["t_user", "t_approver"],
  },
  {
    path: "corporate/preferred-vendors",
    element: <PrefferedPanel />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/vendor-management",
    element: <VendorManagement />,
    roles: ["system_admin"],
  },
  {
    path: "corporate/help-center",
    element: <HelpCenter dashboard={false} />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "corporate/coming-soon",
    element: <ComingSoon />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "*",
    element: <Status404 />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
];

export const TcsRFPRoutes = [
  {
    path: "create/description",
    element: <RfpForm />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "create/scope",
    element: <RfpForm />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "create/bidders",
    element: <RfpForm />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "create/disclose-bidders",
    element: <RfpForm />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "create/preview",
    element: <RfpForm />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "create/submit",
    element: <RfpForm />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "create/bidders",
    element: <Callback />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
];

export const TcsTemplateRfpRoutes = [
  {
    path: "description",
    element: <TemplatePreview />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "scope",
    element: <TemplatePreview />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "bidders",
    element: <TemplatePreview />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
];

export const TcsPastRfpRoutes = [
  {
    path: "description",
    element: <PastRfpPreview />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "scope",
    element: <PastRfpPreview />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
  {
    path: "bidders",
    element: <PastRfpPreview />,
    roles: ["system_admin", "t_user", "t_approver"],
  },
];
